import React from 'react';

// equipment
import equipment1 from './images/equipmentShop/target.png';
import equipment2 from './images/equipmentShop/bag.png';


// metrics
import equipmentChoices from './images/metrics/equipment_choices.png';
import flexibleSubscriptions from './images/metrics/flexible_subscriptions.png';
import onlineVisibility from './images/metrics/online_visibility.png';
import payments from './images/metrics/payments.png';
import pricing from './images/metrics/pricing.png';
import trustedPartners from './images/metrics/trusted_partners.png';

// management
import image1 from './images/management/1.png';
import image2 from './images/management/2.png';
import image3 from './images/management/3.png';
import image4 from './images/management/4.png';
import image5 from './images/management/5.png';
import image6 from './images/management/6.png';
import image7 from './images/management/7.png';
import image8 from './images/management/8.png';
import image9 from './images/management/9.png';
import image10 from './images/management/10.png';
import image11 from './images/management/11.png';

// contacts
import chat from './images/getInTouch/chat.png';
import email from './images/getInTouch/email.png';
import phone from './images/getInTouch/phone.png';
import searchResultsPanel from '../SearchPage/SearchResultsPanel/SearchResultsPanel';


export const equipmentShop = [
  {
    img: equipment1,
    title: 'Empowering Businesses with Smart Equipment Solutions',
    description: 'At HireCompare, we simplify equipment sourcing for businesses. Find what you need hassle-free with our trusted network of providers. Say goodbye to the struggles of equipment hunting and hello to a more productive and cost-efficient way of getting the job done.',
  },
  {
    img: equipment2,
    title: 'Your Go-To Hub for DIY and Landscaping Equipment',
    description: 'Transform your DIY projects and elevate your gardening and landscaping endeavours with ease. HireCompare makes it simple for you to access the right equipment. Say goodbye to the complexities of equipment sourcing, and say hello to effortless access. Discover a world of possibilities with us.',
  },
];

export const metrics1 = [
  {title: 'Endless Equipment Choices at Your Fingertips', img: equipmentChoices},
  {title: 'Confidence in Every Hire & Sale with Our Trusted Partners', img: trustedPartners},
  {title: 'Secure Payments through STRIPE for Peace of Mind', img: payments},
  {title: 'Competitive & Transparent Pricing for All Your Needs', img: pricing},
];

export const metrics2 = [
  {title: <span>Amplify <br/> Your Online <br/> Visibility</span>, img: onlineVisibility},
  {title: <span>Built-In Trust <br/> with Vetted <br/> Users</span>, img: trustedPartners},
  {title: <span>Secure Payments <br/> through STRIPE for <br/> Peace of Mind</span>, img: payments},
  {title: <span>Flexible <br/> Subscription <br/> Pricing</span>, img: flexibleSubscriptions},

];

export const contacts = [
  {icon: email, data: 'support@hirecompare.ie', href: 'mailto:support@hirecompare.ie'},
  {icon: phone, data: '+353 1 912 5209', href: 'tel:+353 1 912 5209'},
  {icon: chat, data: 'Chat With Us Now', chat: true},
]

export const management = [
  {
    img: image1,
    title: 'RFQ Feature',
    text: 'The Request for Quotation (RFQ) feature allows you to withhold pricing until you\'re ready to share it. In a fiercely competitive market, this gives you the flexibility to engage with potential customers on your terms, ensuring you maintain your pricing advantage while still connecting with interested parties.'
  },
  {
    img: image2,
    title: 'Tenders',
    text: 'Access valuable tender opportunities and expand your customer base. Participate in tender requests and grow your business by connecting with new clients who need your services.',
  },
  {
    img: image3,
    title: 'Elevated Premium Profiles',
    text: 'Stand out with an elevated premium profile. Showcase your business with enhanced visibility, credibility, and a prominent position on the platform. Make a lasting impression.',
  },
  {
    img: image4,
    title: 'Analytics',
    text: 'Access in-depth analytics and insights into your online performance. Utilise data-driven information to refine your strategies and improve your efficiency and profitability.',
  },
  {
    img: image5,
    title: 'Mapventory',
    text: 'Gain real-time insight into the whereabouts of your equipment rentals with Mapventory. This active online map view, accessible from your dashboard, displays the precise locations of all your equipment currently out on hire. Stay in control and efficiently manage your rented equipment with this invaluable tool.',
  },
  {
    img: image6,
    title: 'Reviews',
    text: 'Build trust with customer reviews. Receive feedback to improve your services and maintain satisfied clientele. Customer reviews are an essential part of your online reputation.',
  },
  {
    img: image7,
    title: 'Brand & Profile Management',
    text: 'Elevate your brand\'s presence with our user-friendly brand and profile management tools. Tailor your company\'s profile, showcasing your expertise and services to potential customers. Your brand, your way.',
  },
  {
    img: image8,
    title: 'Performance Metrics',
    text: 'Stay informed with real-time performance metrics. Track your success on the platform and make data-driven decisions to optimise your business strategy.',
  },
  {
    img: image9,
    title: 'Hire & Sales Spotlight',
    text: 'Get noticed with special promotions. Hire & Sales Spotlight to showcase your best deals and offerings, driving more attention and inquiries to your business.',
  },
  {
    img: image10,
    title: 'Booking Management',
    text: 'Simplify your operations with our booking management system. Efficiently manage incoming requests, reservations, and availability. Streamline your booking process with ease.',
  },
  {
    img: image11,
    title: 'Inventory Management',
    text: 'Take control of your inventory like never before. Easily add, edit, and manage your equipment listings, ensuring accurate and up-to-date information for potential customers.',
  },


]


